import { Component, OnInit, OnDestroy, inject, DestroyRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { Observable } from 'rxjs';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

import { CloseSilentAuctionComponent } from 'app/virtual-event/components/modals/close-silent-auction/close-silent-auction.component';
import { DeclareLastHeroComponent } from 'app/virtual-event/components/modals/declare-last-hero/declare-last-hero.component';
import { ConfirmComponent } from 'app/core/components/modals/confirm/confirm.component';
import { DialogService } from '../../services/dialog.service';
import { closeDialog } from '../../features/dialog.actions';
import { UpdateVirtualEventComponent } from 'app/virtual-event/components/modals/update-virtual-event/update-virtual-event.component';
import { ShowLiveAuctionMultiComponent } from 'app/virtual-event/components/modals/show-live-auction-multi/show-live-auction-multi.component';
import { debounceTime } from 'rxjs/operators';
import { CropperComponent } from 'app/core/components/modals/cropper/cropper.component';
import { AdditionaGuestInfoComponent } from 'app/core/components/modals/additiona-guest-info/additiona-guest-info.component';
import { FormFieldComponent } from 'app/core/components/modals/form-field/form-field.component';
import { TeamInfoComponent } from 'app/core/components/modals/team-info/team-info.component';
import { LearnMoreComponent } from 'app/core/components/modals/learn-more/learn-more.component';
import { VideoComponent } from 'app/core/components/modals/video/video.component';
import { ImportComponent } from 'app/import/components/import/import.component';
import { ActionSuccessComponent } from 'app/core/components/modals/action-success/action-success.component';
import { AccountRoutingNumberComponent } from 'app/signup/components/modals/account-routing-number/account-routing-number.component';
import { ChangeEmailComponent } from 'app/signup/components/modals/change-email/change-email.component';
import { ContactUsComponent } from '../../../signup/components/modals/contact-us/contact-us.component';
import { ShowAnonymousComponent } from 'app/core/components/modals/show-anonymous/show-anonymous.component';
import { TotalItemCountHelpComponent } from 'app/core/components/modals/total-item-count-help/total-item-count-help.component';
import { AddPendingComponent } from 'app/reports/components/modal/add-pending/add-pending.component';
import { AddOnDonationComponent } from 'app/reports/components/modal/add-on-donation/add-on-donation.component';
import { UpdateCartModalComponent } from 'app/reports/components/modal/update-cart-modal/update-cart-modal.component';
import { RaffleDrawComponent } from 'app/core/components/modals/raffle-draw/raffle-draw.component';
import { SponsorGroupNameComponent } from 'app/sponsor-group/components/modals/sponsor-group-name/sponsor-group-name.component';
import {FaqInfoComponent} from '../../../core/components/modals/faq-info/faq-info.component';
import {RegistrationButtonDialogComponent} from '../../../core/components/modals/registration-button-dialog/registration-button-dialog.component';
import { StreamHelpComponent } from '../../../core/components/modals/stream-help/stream-help.component';
import { PaybeeStreamModalComponent } from '../../../core/components/modals/paybee-stream-modal/paybee-stream-modal.component';
import { VideoModalComponent } from '../../../core/components/modals/video-modal/video-modal.component';
import { StreamPreviewComponent } from '../../../core/components/modals/stream-preview/stream-preview.component';
import { TextDialogComponent } from '../../../core/components/modals/text-dialog/text-dialog.component';
import { BidConfirmComponent } from '../../../core/components/modals/bid-confirm/bid-confirm.component';
import { SurveyModalComponent } from 'app/dashboard/components/modals/survey-modal/survey-modal.component';
import { CopyCampaignComponent } from '../../../core/components/modals/copy-campaign/copy-campaign.component';
import { TicketComboComponent } from 'app/core/components/modals/ticket-combo-modal/ticket-combo-modal.component';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { TablesImportComponent } from 'app/import-tables/components/tables-import/tables-import.component'
import { ImportSlideComponent } from 'app/import/components/import-slide/import-slide.component';
import { ChampionsImportComponent } from 'app/import-champions/components/champions-import/champions-import.component';
import { VolunteersImportComponent } from 'app/import-volunteers/components/volunteers-import/volunteers-import.component';
import { P2pAmountOptionComponent } from 'app/core/components/modals/p2p-amount-option/p2p-amount-option.component';
import { P2pPercentOptionComponent } from 'app/core/components/modals/p2p-percent-option/p2p-percent-option.component';
import { CopyEventDialogComponent } from 'app/event/components/copy-event-dialog/copy-event-dialog.component';
import { SimpleAudianceMonitorDialogComponent } from 'app/event/components/simple-audiance-monitor-dialog/simple-audiance-monitor-dialog.component';
import { CustomReminderComponent } from 'app/core/components/custom-reminder/custom-reminder.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WebHookErrorComponent } from 'app/core/components/modals/web-hook-error/web-hook-error.component';



@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  providers:[MdbModalWrapperService]
})
export class DialogComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public name$: Observable<any> = this.store.pipe(select(selectDialogState));

  public modals = {
    actionSuccess: ActionSuccessComponent,
    closeSilentAuction: CloseSilentAuctionComponent,
    declareLastHero: DeclareLastHeroComponent,
    confirmVirtualEventStart: ConfirmComponent,
    confirmVirtualEventEnd: ConfirmComponent,
    updateVirtualEventModal: UpdateVirtualEventComponent,
    showLiveAuctionMulti: ShowLiveAuctionMultiComponent,
    confirmClearLastHeroWinner: ConfirmComponent,
    confirmResetAuctionData: ConfirmComponent,
    confirmArchiveCampaign: ConfirmComponent,
    confirmComponent: ConfirmComponent,
    cropper: CropperComponent,
    additionalGuestInfo: AdditionaGuestInfoComponent,
    formField: FormFieldComponent,
    addP2PAmountOption:P2pAmountOptionComponent,
    addP2PPercentOption: P2pPercentOptionComponent,
    addTeamInfo:TeamInfoComponent,
    ticketCombo: TicketComboComponent,
    learnMore: LearnMoreComponent,
    showAnonymous: ShowAnonymousComponent,
    totalItemCountHelp: TotalItemCountHelpComponent,
    video: VideoComponent,
    import: ImportComponent,
    importSlide: ImportSlideComponent,
    AccountRoutingNumber: AccountRoutingNumberComponent,
    ChangeEMail: ChangeEmailComponent,
    ContactUs: ContactUsComponent,
    AddPending: AddPendingComponent,
    AddOnDonation: AddOnDonationComponent,
    SponsorGroupName: SponsorGroupNameComponent,
    faqInfo: FaqInfoComponent,
    registrationButtonForm: RegistrationButtonDialogComponent,
    RaffleDraw: RaffleDrawComponent,
    streamHelp: StreamHelpComponent,
    streamPreview: StreamPreviewComponent,
    paybeeVideo: PaybeeStreamModalComponent,
    videoModal: VideoModalComponent,
    customText: TextDialogComponent,
    updateCart: UpdateCartModalComponent,
    bidConfirm: BidConfirmComponent,
    survey: SurveyModalComponent,
    copyCampaign: CopyCampaignComponent,
    importTables: TablesImportComponent,
    importChampions: ChampionsImportComponent,
    importVolunteers: VolunteersImportComponent,
    copyEvent:CopyEventDialogComponent,
    audianceMonitor:SimpleAudianceMonitorDialogComponent,
    customReminder:CustomReminderComponent,
    webhookError:WebHookErrorComponent
  };

  constructor(
    private store: Store<any>,
    private dialogService: DialogService,
    private modalService: MdbModalWrapperService,
  ) {
    this.dialogService.closeDialogSubject.pipe(
      debounceTime(100),
      takeUntilDestroyed()
    ).subscribe((value) => {
      this.store.dispatch({
        type: closeDialog.type,
        payload: value
      });
    })
  }

  ngOnInit(): void {
    this.name$.pipe(
      debounceTime(100),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(state => {
      switch(state.name) {
        case null:
          if(this.dialogService.modalRef instanceof MdbModalRef) {
            try {
              this.dialogService.modalRef.close();
            } catch(e) {}
          }
          break;
        default:
          const modal = this.modals[state.name];
          this.dialogService.modalRef = this.modalService.open(modal, state.options);
      }
    });
  }

  ngOnDestroy() {
  }

}
